import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IPoll } from '../PollsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUsePollQueryValues = {
  appId: string;
  pollId: string;
};

export const pollQueryKeyFactory: IQueryKeyFactory<IUsePollQueryValues> = (
  values,
) => values && (['poll', values.appId, values.pollId] as const);

export const usePollQuery = (
  values?: IUsePollQueryValues,
  options?: UseQueryOptions<IPoll, ApiError>,
): UseQueryResult<IPoll, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: pollQueryKeyFactory(values),
    queryFn: values
      ? () => api.polls.get(values.appId, values.pollId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
